import React from 'react';

import {
  DeleteIcon,
  EditPenIcon,
  PrimaryIcon,
  UserEditIcon,
} from '@sharedCR/coreDesignSystem/icons';

import { IconSize } from 'constants/coreDesignSystem';

export const orderContactActionIcons = {
  setAsPrimary: <PrimaryIcon size={IconSize[20]} />,
  edit: <EditPenIcon size={IconSize[20]} />,
  openAgentAndSeller: <UserEditIcon size={IconSize[20]} />,
  remove: <DeleteIcon size={IconSize[20]} />,
};
